import { supabase } from '../lib/supabase';

/**
 * Servicio centralizado para gestionar operaciones de impeachment (reportes de usuarios).
 * Todas las llamadas a Supabase relacionadas con impeachment se manejan aquí.
 * Adaptado para web desde amarsi-app.
 */

// Obtiene un impeachment existente entre un gestor y un usuario demandado
export const getImpeachmentByUsers = async (gestorId, demandadoId) => {
  console.log('=== DEBUG getImpeachmentByUsers ===');
  console.log('Buscando impeachment con:');
  console.log('- gestorId:', gestorId);
  console.log('- demandadoId:', demandadoId);
  
  try {
    const { data, error } = await supabase
      .from('impeachment')
      .select('*')
      .match({
        gestor: gestorId,
        demandado: demandadoId,
      })
      .single();

    console.log('Respuesta de Supabase:');
    console.log('- data:', data);
    console.log('- error:', error);

    if (error && error.code !== 'PGRST116') { // PGRST116 = no rows found
      console.error('ERROR real (no es PGRST116):', error);
      throw error;
    }

    console.log('getImpeachmentByUsers completado, devolviendo:', data);
    return data;
  } catch (error) {
    console.error('Error al obtener impeachment:', error);
    throw error;
  }
};

// Inserta un nuevo registro de impeachment
// Corregido: ahora solo inserta, no actualiza registros existentes
export const upsertImpeachment = async (impeachmentData) => {
  console.log('=== DEBUG upsertImpeachment (INSERT) ===');
  console.log('Datos recibidos:', impeachmentData);
  
  try {
    const insertData = {
      ...impeachmentData,
      type: 1, // Tipo fijo según el código legacy
    };
    
    console.log('Datos para insert:', insertData);
    
    const { data, error } = await supabase
      .from('impeachment')
      .insert(insertData)
      .select()
      .single();

    console.log('Respuesta insert:');
    console.log('- data:', data);
    console.log('- error:', error);

    if (error) {
      console.error('ERROR en insert:', error);
      throw error;
    }

    console.log('upsertImpeachment (insert) completado exitosamente');
    return data;
  } catch (error) {
    console.error('Error al insertar impeachment:', error);
    throw error;
  }
};

// Actualiza un impeachment existente por ID
// Corregido: si la actualización falla porque no existe el registro, hace upsert automáticamente.
export const updateImpeachment = async (id, impeachmentData) => {
  console.log('=== DEBUG updateImpeachment ===');
  console.log('ID a actualizar:', id);
  console.log('Datos para actualizar:', impeachmentData);
  
  if (!id) {
    console.error('ERROR: ID es null o undefined');
    throw new Error('ID es requerido para actualizar impeachment');
  }
  
  try {
    const updateData = {
      ...impeachmentData,
      type: 1, // Tipo fijo según el código legacy
    };
    
    console.log('Datos finales para update:', updateData);
    
    const { data, error } = await supabase
      .from('impeachment')
      .update(updateData)
      .eq('id', id)
      .select();

    console.log('Respuesta update:');
    console.log('- data:', data);
    console.log('- error:', error);

    // No usar .single() aquí ya que puede no devolver filas
    if (error) {
      console.error('ERROR en update:', error);
      throw error;
    }

    if (!data || data.length === 0) {
      console.warn('ADVERTENCIA: No se encontró el impeachment para actualizar, intentando crear nuevo...');
      // Si no se encontró el registro, crear uno nuevo con upsert
      return await upsertImpeachment(impeachmentData);
    }

    console.log('updateImpeachment completado exitosamente');
    return data[0]; // Devolver el primer resultado
  } catch (error) {
    console.error('Error al actualizar impeachment:', error);
    throw error;
  }
};
